import { render, staticRenderFns } from "./ModalEnviarGeometriaDiagnostico.vue?vue&type=template&id=1cc96740&scoped=true&lang=pug"
import script from "./ModalEnviarGeometriaDiagnostico.vue?vue&type=script&lang=js"
export * from "./ModalEnviarGeometriaDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./ModalEnviarGeometriaDiagnostico.vue?vue&type=style&index=0&id=1cc96740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc96740",
  null
  
)

export default component.exports